<div class="header">
    <div class="shortinfo">

        <div class="stat-card" *ngFor="let info of shortinfo"  >
            <div class="stat-primary">
              <span class="comingsoon" >{{info.info}}</span>
                <span class="name">{{info.name}} <span [innerHTML]="info.icon" [style.color]="info.color"></span></span>
                <h4 [ngStyle]="{'color': info.color}"> {{info.value}}</h4>
                <p class="lilInfo">{{info.increase}}</p>
            </div>
            <div class="stat-icon">

            </div>
        </div>


    </div>
</div>
<div class="left-right-wrapper">
    <div class="left">


 
        <div class="adtTracking">

            <label> <i class="fa fa-thumb-tack" aria-hidden="true"></i> Tracking</label>

            <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" [animationDuration]="'0ms'" (selectedTabChange)="!initialized || onTabChanged($event)">
               <mat-tab *ngFor="let tab of adtTrackingtabs;let i = index"  [label]="tab.processStageName + ' (' + tab.count + ')'">
                <div class="tabContent">
                 <ng-container *ngIf="adtTrackingAdmission.length > 0">
                     <table class="table">
                        <tr>
                            <th width="30%">&nbsp;</th>                            
                             <th width="40%">&nbsp;</th>
                            <th width="10%">&nbsp;</th>
                        </tr>
                       <tr *ngFor="let item of adtTrackingAdmission; let rowIndex = index" >
                        
                        <ng-container  >
                        
                        <td>
                                <p class="patientName" >
                                 <ng-container *ngFor="let field of item.core?.fields">
                                  <div *ngIf="field.fieldName === 'Name'">
                                   <a style="cursor: pointer;" (click)="OpenDetails(item.core,'details')">{{ field.fieldValue }} </a>
                                   </div>
                                    
                                 </ng-container>

                                   
                                  

                                 <ng-container>

                                  <div class="actions">
                                    <button mat-icon-button color="primary" class="openNew"  matTooltip="Open in new window" (click)="OpenProfile(item.core?.fields)">
                                    <mat-icon>open_in_new</mat-icon> 
                                   </button>
                               

                                <p class="patientName" >
                                    <i (click)="openUploadDocumentPopupForAI(item,item.core)" class="fa fa-reddit-alien border" aria-hidden="true"
                                     matTooltip="Upload Documents" matTooltipPosition="above"></i>

                                    <span class="conlist border" *ngIf="item.coreTask"  matTooltip="Task Progress: {{ item.coreTask.completedTasks }} completed out of {{ item.coreTask.totalTasks }} total tasks"
                                        matTooltipPosition="above">
                                        <i class="fa fa-file-text-o" aria-hidden="true"></i>
                                        {{ item.coreTask.completedTasks }}/{{ item.coreTask.totalTasks }}
                                    </span>
                                    <span class="conlist border" *ngIf="!item.coreTask"  matTooltip="No tasklist associate with this stage for this person."
                                        matTooltipPosition="above">
                                        <i class="fa fa-file-text-o" aria-hidden="true"></i>
                                        {{ 0 }}/{{ 0 }}
                                    </span>

                                    <i class="fa fa-list" aria-hidden="true" 
                                     matTooltip="Open Task List" matTooltipPosition="above"
                                     (click)="openTaskList(item,item.core)">
                                    </i>
                                 </p>
                                  </div>

                                 </ng-container>


                                </p>
                                
                                <p class="smallInfo">
                                 <ng-container *ngFor="let field of item.core?.fields">
                                  <div *ngIf="field.fieldName === 'Email'">
                                   {{ field.fieldValue }}
                                   </div>
                                 </ng-container>
                                </p>
                                <!-- <p class="smallInfo">Age 78 Pending </p>
                                <p class="smallInfo"> Post-surgical care</p>
                                <p class="textWithIcon"> <mat-icon>access_time</mat-icon> 10:30 AM</p> -->
                                <div class="textWithIcon" style="display: flex; align-items: center; gap: 6px;">
                                    <mat-icon class="clock-icon">access_time</mat-icon>
                                    <span class="date-container" matTooltip="Stage Changed Date Time"  matTooltipPosition="above"  *ngIf="item?.core?.stageChangedOn == '0001-01-01T00:00:00'">
                                        Stage not changed yet.
                                    </span>
                                    <span class="date-container"  matTooltip="Stage Changed Date Time"  matTooltipPosition="above"  *ngIf="item?.core?.stageChangedOn !== '0001-01-01T00:00:00'">
                                        {{item?.core?.stageChangedOn+'Z' | date: 'MM/dd/yyyy' }}
                                    </span>
                                    
                                    <button class="actIconbutton">
                                     <mat-icon *ngIf="item.core.isFavorite == true"
                                      class="fav default-flag star" [ngStyle]="{ 'color': item.core.favouriteColorCode }"
                                       (click)="FavoriteSelectedRecordForDeleteCore(item.core)">grade</mat-icon>                                      
                                     <mat-icon style="cursor: pointer;" *ngIf="item.core.isFavorite == false" (click)="AddRowFavorites(item.core,selectFavColor)" class="star" >grade</mat-icon>
                                    </button>

                                    
   <button 
  class="actIconbutton"
  > 
  <!-- When Important -->
  <i 
    *ngIf="item.core.isImportant" 
    class="fa fa-flag default-flag fav" 
    [ngStyle]="{ 'color': item.core.isImportantColorCode, 'cursor': 'pointer' }"
    (click)="DeleteImportant(item.core)">
  </i>

  <!-- When Not Important -->
  <i 
    *ngIf="!item.core.isImportant" 
    class="fa fa-flag default-flag star" 
    (click)="AddRowImportant(item.core, selectimpFavColor)"
     [ngStyle]="{ 'cursor': 'pointer' }">
  </i>
</button>           




                                        <button class="actbutton" (click)="OpenDetails(item.core,'note')">
                                       <i class="fa fa-plus" aria-hidden="true"></i>  Add Note
                                       </button>

   <!-- <button mat-icon-button>
  <svg xmlns="http://www.w3.org/2000/svg" height="28px" viewBox="0 -960 960 960"
    [attr.fill]="item?.core?.isImportant ? '#FFD700' : '#1f1f1f'"
    width="28px">
    <path d="m80-160 240-320L80-800h520q19 0 36 8.5t28 23.5l216 288-216 288q-11 15-28 23.5t-36 8.5H80Zm160-80h360l180-240-180-240H240l180 240-180 240Zm270-240Z"/>
  </svg>
</button> -->

                                </div>
                             
                            </td>
                           
                            <td>
                             <div class="allFolderList">
                               <div class="folderList" *ngFor="let folder of item.coreDocFolders">
                                <p class="roleLabel"> 
                                  <!-- <i class="fa fa-file-text-o" aria-hidden="true"></i> -->

                                 {{ folder.folderName }}
                                </p>

                                <p class="doucmentInline">
                                  <ng-container *ngFor="let ph of folder.placeholders">
                                                                                                      
                                    <div class="tooltipHolder" [ngClass]="{'firstrow': rowIndex == 0 || rowIndex == 1 }" >        
                                      
                                    <!-- <i *ngIf="ph.projectStatus != 3" class="fa fa-file-text-o grey" aria-hidden="true"></i> -->
                                    <!-- <i *ngIf="ph.formID == 0" class="fa fa-file-text-o grey" aria-hidden="true"></i>  -->
                                    
                                    <!-- For Blank PlaceHolder and upload document -->
                                    <i *ngIf="ph.placeholderType ==0 && ph.projectID == 0 && ph.formType == 0" class="fa fa-file-pdf-o grey" aria-hidden="true"></i> 
                                    
                                     <!-- For Forms PlaceHolder and Create Projects -->
                                    <i *ngIf="ph.placeholderType ==2 && ph.projectID == 0 && ph.formType == 1" class="fa fa-file-text-o grey" aria-hidden="true"></i> 
                                    
                                    <!-- For Upoladed documents and PDF -->
                                    <i *ngIf="ph.placeholderType==1 && ph.formType==0 && ph.projectID == 0" class="fa fa-file-pdf-o" style="color: red;" aria-hidden="true" ></i>
                                  
                                    <i *ngIf="ph.placeholderType==2 && ph.formType==2 && ph.projectID > 0" class="fa fa-html5 orange" style="color: #ed7b1a;" aria-hidden="true" ></i>

                                    <!-- <i *ngIf="ph.formID > 0 && ph.formType == 3" class="fa fa-html5 orange" style="color: #ed7b1a;" aria-hidden="true" ></i> -->
                                    <i *ngIf="ph.formID > 0 && ph.projectID > 0 && (ph.projectStatus == 0 || ph.projectStatus == 1 || ph.projectStatus == 2) && ph.formType!=2" class="fa fa-file-text blue" style="color: #1E90FF;"  aria-hidden="true"></i>
                                    <i *ngIf="ph.formID > 0 && ph.projectID > 0 && ph.projectStatus == 3"  class="fa fa-check-circle-o green" aria-hidden="true"></i>
                                     <!-- <i *ngIf="ph.projectStatus == 3"  class="fa fa-check-circle-o green" aria-hidden="true" matTooltip="{{ ph.placeholderName }} - Completed" matTooltipPosition="above"></i> -->
                                       
                                        <div class="customTooltip newLook">

                                            <div class="documentList">

                                                    <div class="topAligner">
                                                         <app-doc-icons *ngIf="ph.placeholderType==2 && ph.formType!=2 && ph.formType!=3" [iconType]="'FORM'"></app-doc-icons>
                                                         <app-doc-icons *ngIf="ph.placeholderType==1 && ph.formType!=2 && ph.formType!=3" [iconType]="'PDF'" (click)="openPDFViewer(ph,item.core)"></app-doc-icons>
                                                         <app-doc-icons [iconType]="'UPLOAD'" *ngIf="ph.placeholderType==0 && ph.formType!=2 && ph.formType!=3" ></app-doc-icons>

                                                           <div class="status">
                                                            <span *ngIf="ph.isFilled==true" class="formLabel fillForm">Filled </span>
                                                            <span *ngIf="ph.projectID>0 && ph.projectStatus==0" class="formLabel draftedForm">Draft </span>
                                                            <span *ngIf="ph.projectID>0 && ph.projectStatus==1" class="formLabel sentForm">Sent </span>
                                                            <span *ngIf="ph.projectID>0 && ph.projectStatus==2" class="formLabel inprogressForm">In Progress </span>
                                                            <span *ngIf="ph.projectID>0 && ph.projectStatus==3" class=" formLabel completedForm">Complete</span>
                                                            <span *ngIf="ph.projectID>0 && ph.projectStatus==4" class="formLabel withDrawForm">Withdraw </span>
                                                            <span *ngIf="ph.projectID>0 && ph.projectStatus==5" class=" formLabel declineForm">Decline  </span>
                                                    
                                                        </div>
                                                        
                                                    </div>
                                                    <div class="docInfo">
                                              
                                                         {{ph.placeholderName}}
                                                    </div>
                                                    <div class="docaction">
                                               <!-- if placeholder type ==2  and formtype ==1 then show form Icon  -->
                                            <ul *ngIf="ph.placeholderType==2 && ph.formType==1">
                                                         
                                                 <li *ngIf="ph.projectID > 0 && ph.projectStatus==0 || ph.projectStatus==1">
                                                   <a (click)="FillSelectForm(ph,item.core)">
                                                    <i class="fa fa-pencil-square-o" aria-hidden="true"></i> Fill Data
                                                  </a> 
                                                </li>
                                                
                                                 <li *ngIf="ph.projectID==0">
                                                    <a (click)="creatProject(ph,item.core)">
                                                      <i class="fa fa-plus" aria-hidden="true"></i> Create
                                                   </a>
                                                 </li>
                                                  <li *ngIf="ph.projectID>0  && ph.projectStatus!=3">
                                                    <a (click)="EditProject(ph,item.core)">
                                                      <i class="fa fa-plus" aria-hidden="true"></i> Edit Signers
                                                   </a>
                                                  </li>
                                                 <li *ngIf="ph.projectID>0  && ph.projectStatus!=3">
                                                    <a (click)="EditForm(ph,item.core)">
                                                      <i class="fa fa-plus" aria-hidden="true"></i> Edit Form
                                                   </a>
                                                 </li>
                                                  <li>
                                                    <a (click)="showDocumentDetails(ph,item.core)">
                                                      <i class=""></i> Details
                                                   </a>
                                                 </li>
                                                  <li *ngIf="ph.projectID==0">
                                                    <a (click)="signNow(ph.token,ph,item.core)">
                                                      <i class="fa fa-pencil" aria-hidden="true"></i> Quick Self Sign
                                                   </a>
                                                 </li>
                                                 <!-- <li><a href="#"><i class="fa fa-pencil-square-o" aria-hidden="true"></i> Fill</a> </li>
                                                 <li><a href="#"><i class="fa fa-pencil" aria-hidden="true"></i> Sign</a> </li> -->
                                            </ul>

                                              <!-- if placeholder type ==0  and formtype ==0 then show placeholder  -->
                                               <ul *ngIf="ph.placeholderType==0 && ph.formType==0">                                                
                                                
                                                 <li>
                                                    <a>
                                                      <input #Input hidden="true" type="file" (change)="onFileSelectPlaceHolder($event,ph, item.core)">
                                                        <div class="uploadfile" (click)="Input.click()">
                                                        <i class="fa fa-cloud-upload" aria-hidden="true"></i> Upload File
                                                      </div>
                                                       
                                                   </a>
                                                 </li>
                                                  <li>
                                                    <a (click)="showDocumentDetails(ph,item.core)">
                                                       <i class="fa fa-info-circle" aria-hidden="true"></i> Details
                                                   </a>
                                                 </li>
                                               
                                            </ul>

                                             <!-- if placeholder type ==2 and formType==3 then show html Icon  -->
                                            <ul *ngIf="ph.placeholderType==2 && ph.formType==3">
                                                 <li >
                                                   <a >
                                                    <i class="fa fa-pencil-square-o" aria-hidden="true"></i> Fill
                                                  </a> 
                                                </li>
                                                 <li >
                                                    <a >
                                                      <i class="fa fa-pencil" aria-hidden="true"></i> View
                                                   </a>
                                                 </li>
                                               <li>
                                                    <a (click)="showDocumentDetails(ph,item.core)">
                                                      <i class=""></i> Details
                                                   </a>
                                                 </li>
                                               
                                            </ul>

                                             <!-- if placeholder type ==1 and formType==0 then show pdf  -->
                                            <ul *ngIf="ph.placeholderType==1 && ph.formType==0">
                                                   <!-- <li >
                                                   <a >
                                                    <i class="fa fa-pencil-square-o" aria-hidden="true"></i> Open AI
                                                  </a> 
                                                </li> -->

                                                 <!-- <li >
                                                   <a (click)="FillPlaceholderForDocument(ph,item.core)">
                                                    <i class="fa fa-pencil-square-o" aria-hidden="true"></i> Fill
                                                  </a> 
                                                </li> -->
                                                <li>
                                                    <a (click)="showDocumentDetails(ph,item.core)">
                                                      <i class=""></i> Details
                                                   </a>
                                                 </li>
                                                 <li>
                                                    <a (click)="DownloadSigleFile(ph,item.core)">
                                                      <i class=""></i> Download
                                                   </a>
                                                 </li>
                                               
                                            </ul>

                                            <!-- if placeholder type ==2 and formType==2 then show tabular  -->
                                             <ul *ngIf="ph.placeholderType==2 && ph.formType==2">  
                                              
                                               <li>
                                                    <a (click)="showDocumentDetails(ph,item.core)">
                                                      <i class=""></i> Details
                                                   </a>
                                                 </li>

                                              <li *ngIf="ph.projectID>0">
                                                    <a (click)="signNow(ph.token,ph,item.core)">
                                                      <i class="fa fa-pencil" aria-hidden="true"></i> Quick Self Sign
                                                   </a>
                                                 </li>

                                               
                                                
                                               
                                            </ul>

                                           </div>
                                        </div>                                           
                                          
                                        </div>
                                    </div>
                                   
                                  

                                   </ng-container>
                                </p>                               
                              </div>
                             </div>
                            </td>
                            <td class="text-right">
                                <p *ngIf="item.core.status" class="statusTask fill">{{item.core.status}}</p>
                                <p>                                    
                                     <mat-select placeholder = "Process Stage" [(ngModel)]="item.core.processStageID" [attr.value]="item.core.processStageID"
                                        (selectionChange)="changeProcessStageForCore(item.core.processStageID,$event.value,item.core.coreID,item)" (ngModel)="item.core.processStageID"  name = "processStage">
                                        <mat-option value="0" >select</mat-option>
                                        <mat-option *ngFor = "let stage of stageProcessList" 
                                            [value] = "stage.processStageID">
                                            {{stage.processStageName}}
                                        </mat-option>
                                </mat-select>
                                </p>
                                <!-- <p><button class="dbtn blackBtn">Assign Rooms</button></p> -->
                            </td>

                          </ng-container>
                        </tr>

                  </table>
                 </ng-container>
                 
                </div>
                   
                <!-- <div class="tabContent" *ngIf="tab.processStageName =='Discharges'" >
                  <p>{{ tab.processStageName }} Content</p>
                </div>

                <div class="tabContent" *ngIf="tab.processStageName =='Transfers'">
                  <p>{{ tab.processStageName }} Content</p>
                </div>

                <div class="tabContent" *ngIf="tab.processStageName =='COC'">
                  <p>{{ tab.processStageName }} Content</p>
                </div> -->
              

                </mat-tab>
                
            </mat-tab-group>

        </div>


        <div class="adtTracking" *ngif="false">

            <label> <i class="fa fa-user-o" aria-hidden="true"></i> Last 5 Residents Managed</label>

            <div class="residentBlock">

                <div class="image">
                    DK
                </div>

                <div class="residentInfo">
                    <h4>Dorothy Martinez</h4>
                    <p>Age 84 &nbsp; Room 101</p>
                    <p>Last Activity: Medication administered 30 min ago</p>
                    <p>Managed by: Nurse Williams</p>
                </div>

                <div class="action">
                    <p class="label fill">Stable</p>
                    <button mat-icon-button><mat-icon>more_horiz</mat-icon></button>
                </div>

            </div>
            <div class="residentBlock">

                <div class="image">
                    DK
                </div>

                <div class="residentInfo">
                    <h4>Dorothy Martinez</h4>
                    <p>Age 84 &nbsp; Room 101</p>
                    <p>Last Activity: Medication administered 30 min ago</p>
                    <p>Managed by: Nurse Williams</p>
                </div>

                <div class="action">
                    <p class="label fill">Stable</p>
                    <button mat-icon-button><mat-icon>more_horiz</mat-icon></button>
                </div>

            </div>

        </div>


        <div class="adtTracking" *ngif="1!=1">

            <label> <i class="fa fa-shield" aria-hidden="true"></i>
                Audit & Compliance Dashboard</label>

            <mat-tab-group mat-stretch-tabs="true">
                <mat-tab label="overview">

                    <div class="auditBlocks">

                        <div class="blocks">
                            <h5 class="green">92%</h5>
                            <p>Overall Compliance</p>
                        </div>

                        <div class="blocks">
                            <h5 class="red">3</h5>
                            <p>Critical Findings</p>
                        </div>

                        <div class="blocks">
                            <h5 class="orange">8</h5>
                            <p>Corrections Pending</p>
                        </div>

                    </div>

                    <div class="auditTimline adtTracking">
                        <label> <i class="fa fa-calendar" aria-hidden="true"></i>
                            Audit Timeline</label>

                            <p class="auditTime" >Last Survey:  <span>Jan 15, 2025</span></p>
                            <p class="auditTime" >Next Expected: <span>May 15, 2025</span></p>

                    </div>

                    <div class="reports">
                        <span class="label adtTracking mb-0"> <i class="fa fa-file-text-o" aria-hidden="true"></i>
                            Genreate Compliance Reports</span>

                             <span class="label adtTracking mb-0"> <i class="fa fa-file-text-o" aria-hidden="true"></i>
                            Quality Metrics</span>

                    </div>

                </mat-tab>
                <mat-tab label="Potential"> Potential </mat-tab>
                <mat-tab label="Compliance"> Compliance </mat-tab>
                <mat-tab label="Findings"> Findings</mat-tab>
            </mat-tab-group>

        </div>

        <div class="adtTracking" *ngif="1!=1">

            <label> <i class="fa fa-bolt" aria-hidden="true"></i>
                Recent Activity</label>

            <div class="residentBlock">

                <div class="image">
                    <i class="fa fa-stethoscope green" aria-hidden="true"></i>

                </div>

                <div class="residentInfo">
                    <h4>New Admission Completed <span class="activity admissionType">Admission</span></h4>
                    <p>Sarah Johnson admitted to Room 301B</p>
                    <div class="personTIme">
                        <p><i class="fa fa-user-o" aria-hidden="true"></i> Nurse Williams</p>
                        <p><i class="fa fa-clock-o" aria-hidden="true"></i>30 minutes ago</p>
                    </div>
                </div>



            </div>

        </div>

    </div>
    <div class="right">

<!-- Signatures Section -->
<div class="signatures-card">
  <div class="signatures-header">
    <div class="left">
      <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
      <span>Signatures</span>
    </div>
    <!-- <a class="view-all">View all</a> -->
  </div>

  <div class="signatures-status">
    <div class="status-item" (click)="OpenReadyToSignature('ReadyToSign')">
      <span class="label">Ready</span>
      <span class="count">{{totalReadyToSign}}</span>
    </div>
    <div class="status-item" (click)="OpenReadyToSignature('Pending')">
      <span class="label">Pending</span>
      <span class="count">{{totalPending}}</span>
    </div>
    <div class="status-item" (click)="OpenReadyToSignature('Drafts')">
      <span class="label">Drafts</span>
      <span class="count">{{totalDrafts}}</span>
    </div>
  </div>
</div>

<!-- Document Signatures Section -->
<div class="signatures-card">
<div class="secHeader">
  <label><i class="fa fa-file-text" aria-hidden="true"></i> Document Signatures</label>
</div>

<div class="doc-signatures">
  <!-- Start Project -->
  <div class="doc-card start-card">
    <i class="fa fa-plus card-icon"></i>
    <h4>Start Project</h4>
    <p>Upload document and Add Signers</p>
    <button class="btn start-btn" (click)="startNewSignatureProject()">Start</button>
  </div>

  <!-- Quick Sign -->
  <!-- <div class="doc-card quick-card">
    <i class="fa fa-upload card-icon"></i>
    <h4>Quick Sign</h4>
    <p>Click to upload & sign instantly</p>
    <button class="btn quick-btn" (click)="quickSignDocument()">Upload</button>
  </div> -->
</div>

</div>

<mat-card class="quick-links-card">

  <!-- Header -->
  <div class="headerlink">
    <div class="title">
      <mat-icon>link</mat-icon>
      <span class="title-text">Quick Links</span>
    </div>

    <div class="actions">
      <button mat-stroked-button class="favorites-btn">
        <span class="count">{{ favoritesCount }}</span> favorites
      </button>
      <button mat-stroked-button (click)="openPopup(AddLink)">
        <mat-icon>add</mat-icon>
        Add
      </button>
      <!-- <button mat-icon-button>
        <mat-icon>settings</mat-icon>
      </button> -->
    </div>
  </div>

  <!-- Grid -->
  <div class="links-grid">
    <div class="link-card" *ngFor="let link of displayQuickLinks" >
      <div class="link-header">
       <button (click)="openLink(link)"mat-icon-button  class="colored-icon" 
           [ngStyle]="{'background-color': link.color}">
           <mat-icon>{{ link.icon }}</mat-icon>
        </button>
        <span class="chip" [ngClass]="link.type" (click)="openLink(link)">{{ link.type }}</span>
         <mat-icon *ngIf="link.isFavorite" class="fav" (click)="AddRowFavorite(link,false)">grade</mat-icon>
         <mat-icon *ngIf="!link.isFavorite" class="star" (click)="AddRowFavorite(link,true)">grade</mat-icon>
      </div>
      
      <div class="label" (click)="openLink(link)">{{ link.name }}</div>
    </div>
  </div>

  <!-- Show more / less -->
  <div class="toggle-btn" *ngIf="allQuickLinks.length > visibleCount"
       (click)="toggleShow()">
    {{ showAll ? 'Show less' : 'Show more' }}
  </div>

</mat-card>




        <div class="secHeader" *ngif="1!=1">
            <label> <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                Compliance Alerts</label>
            <div class="numsec">
                <button class="highPriority dbtn">29</button>
                <button class="dbtn">34 total</button>
            </div>
        </div>

        <div class="alert-item alert-red" *ngif="1!=1">
            <div class="flex items-start gap-3">
                <div class="flex-1">
                    <div class="flex items-center justify-between mb-2">
                        <h4 class="font-medium"> <i class="fa fa-line-chart red" aria-hidden="true"></i>Change of
                            Condition</h4>
                        <span class="badge badge-destructive">9</span>
                        <button class="highPriority dbtn">High Priority</button>
                    </div>
                    <p class="text-sm text-muted-foreground mb-3">Residents with significant condition changes requiring
                        documentation</p>
                    <button class="viewBtn dbtn"> View 9 Residents</button>
                </div>
            </div>
        </div>

        <div class="alert-item alert-blue" *ngif="1!=1">
            <div class="flex items-start gap-3">
                <div class="flex-1">
                    <div class="flex items-center justify-between mb-2">
                        <h4 class="font-medium"> <i class="fa fa-certificate blue" aria-hidden="true"></i> MDS
                            Suggestions</h4>
                        <span class="badge badge-destructive">12</span>
                        <button class="highPriority dbtn">High Priority</button>
                    </div>
                    <p class="text-sm text-muted-foreground mb-3">Residents requiring MDS assessment updates</p>
                    <button class="viewBtn dbtn"> View 9 Residents</button>
                </div>
            </div>
        </div>

        <div class="alert-item alert-red" *ngif="1!=1">
            <div class="flex items-start gap-3">
                <div class="flex-1">
                    <div class="flex items-center justify-between mb-2">
                        <h4 class="font-medium"> <i class="fa fa-file-text-o red" aria-hidden="true"></i> Certificate of
                            Coverage</h4>
                        <span class="badge badge-destructive">9</span>
                        <button class="highPriority dbtn">High Priority</button>
                    </div>
                    <p class="text-sm text-muted-foreground mb-3">Missing Certificate of Coverage documentation</p>
                    <button class="viewBtn dbtn"> View 8 Residents</button>
                </div>
            </div>
        </div>

        <div class="alert-item alert-orange" *ngif="1!=1">
            <div class="flex items-start gap-3">
                <div class="flex-1">
                    <div class="flex items-center justify-between mb-2">
                        <h4 class="font-medium"> <i class="fa fa-calendar-o orange" aria-hidden="true"></i> Timely
                            Braden Scale Missing</h4>
                        <span class="badge badge-destructive">9</span>
                        <button class="mediumPriority dbtn">Medium Priority</button>
                    </div>
                    <p class="text-sm text-muted-foreground mb-3">Overdue Braden Scale assessments</p>
                    <button class="viewBtn dbtn"> View 8 Residents</button>
                </div>
            </div>
        </div>

    </div>
</div>




<ng-template #addFolderDialog *ngif="1!=1">
  <h2 matDialogTitle>{{selectedTab}}</h2>
  <mat-dialog-content>

    <div class="" *ngIf="selectedTab === 'Skilled Mix'">
        <div class="graph">
        <label>Payor Mix Breakdown</label>

         <div class="graphHolder">
            <div class="leftgraph">
                <h5>Skilled Residents (91 total)</h5>
                 <div class="graphHere">
                    <img src="assets/images/chart1.png" alt="Line Chart" />
                </div>
            </div>
            <div class="rightgraph">
                <h5>Non-Skilled Residents (36 total)</h5>
                  <div class="graphHere">
                    <img src="assets/images/chart2.png" alt="Line Chart" />
                </div>
            </div>
         </div>

    </div>

    <div class="graph">
        <label>Skilled vs Non-Skilled Trends</label>

         <div class="graphHolder">
            <div class="leftgraph">
                <h5>Resident Count Over Time</h5>
                <div class="graphHere">
                   
                <mat-tab-group mat-stretch-tabs="true">
                <mat-tab label="Last Month">

                     <img src="assets/images/chart3.png" alt="Line Chart" />

                </mat-tab>
                <mat-tab label="Past 3 Months"> Content 2 </mat-tab>
                <mat-tab label="Past 6 Months"> Content 3 </mat-tab>
                <mat-tab label="Past 12 Months"> Content 4</mat-tab>
            </mat-tab-group>




                </div>
            </div>
            <div class="rightgraph">
                <h5>Payor Mix Trends</h5>
                 <div class="graphHere">
                   
                <mat-tab-group mat-stretch-tabs="true">
                <mat-tab label="Last Month">

                     <img src="assets/images/chart4.png" alt="Line Chart" />

                </mat-tab>
                <mat-tab label="Past 3 Months"> Content 2 </mat-tab>
                <mat-tab label="Past 6 Months"> Content 3 </mat-tab>
                <mat-tab label="Past 12 Months"> Content 4</mat-tab>
            </mat-tab-group>




                </div>
            </div>
         </div>

    </div>
    </div>

     <div class="" *ngIf="selectedTab === 'Census'">
        

    <div class="graph">
       
         <div class="graphHolder">
            <div class="leftgraph w100">
                <h5>Resident Count Over Time</h5>
                <div class="graphHere">
                   
                <mat-tab-group mat-stretch-tabs="true">
                <mat-tab label="Last Month">

                     <img src="assets/images/chart5.png" alt="Line Chart" />

                </mat-tab>
                <mat-tab label="Past 3 Months"> Content 2 </mat-tab>
                <mat-tab label="Past 6 Months"> Content 3 </mat-tab>
                <mat-tab label="Past 12 Months"> Content 4</mat-tab>
            </mat-tab-group>




                </div>
            </div>
         </div>

    </div>
    </div>

  </mat-dialog-content>
  <mat-dialog-actions
    align="start"
    fxLayout="row"
    fxLayoutAlign="space-between center"
  >
    <button mat-button  color="basic" >
      Cancel
    </button>
    <button
      mat-button
      color="primary"
     
    >
      Add
    </button>
  </mat-dialog-actions>
</ng-template> 




 <app-3cDocument-details *ngIf="openDocumentDetail==true" [ngClass]="{ open: openDocumentDetail }"
  [documentData]="selectedDocument" [transactionID]="transactionID" (closeEmit)="getClose($event)">
  </app-3cDocument-details>

   <app-document-viewer3c *ngIf="openDocumentViewers==true" [ngClass]="{ open: openDocumentViewers }"
  [documentData]="selectedDocument" [transactionID]="transactionID" (getCloseDocumentViewer)="getCloseDocumentViewer($event)">
  </app-document-viewer3c>


    <ng-template #AddLink>
    <h2 mat-dialog-title>
      <span class="groupIcon"><mat-icon>rocket_launch</mat-icon></span>
      Add Quick Link
      <button mat-icon-button (click)="closeSendTaskListURL()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>
    <mat-dialog-content>


      <div>

        <mat-form-field appearance="outline">
          <mat-label>Icon name</mat-label>
          <input matInput placeholder="Icon name" id="urlname">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Add link </mat-label>
          <input matInput placeholder="Add link name" id="urllink">
        </mat-form-field>
    
      <div class="iconNColor">
        <div class="selectedIcon" >
          <button mat-stroked-button color="primary" (click)="selectIcon()">
            Select Icon
          </button>
          <div *ngIf="formIcon!=''">
            <button mat-icon-button><mat-icon>{{formIcon}}</mat-icon></button>
          </div>
        </div>
        

        <div class="charColor" [formGroup]="addQuickLinkForm">
          <div class="colGroup">
            <ng-container *ngIf="PersonalChecked || PortalChecked">
              <ng-container *ngFor="let color of col; let i as index">
                <label class="colm" [ngStyle]="{'background-color': color.colname }">
                  <input type="radio" id="{{i}}" type="radio" value="{{color.colname}}" name="noteColor"
                    formControlName="quickLink">
                  <span class="checkmark"></span>
                </label>
              </ng-container>
            </ng-container>

          </div>        
        </div>

      </div>


     
      </div>


    </mat-dialog-content>


    <mat-dialog-actions class="mt-10" align="start" fxLayout="row" fxLayoutAlign="space-between center">
      <button mat-button color="basic" (click)="closeSendTaskListURL()">Cancel</button>
      <button mat-flat-button class="calltoaction" type="submit" color="primary" (click)="addDashboardQuicklink(addQuickLinkForm.value)">
        Save
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
          </mat-spinner></mat-icon>
      </button>
    </mat-dialog-actions>

  </ng-template>


    <ng-template #SendTaskListURL>
    <h2 mat-dialog-title>
      <span class="groupIcon"><mat-icon>mail</mat-icon></span>
      Create and send tasklist
      <button mat-icon-button (click)="closeSendTaskListURL()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>
    <mat-dialog-content>

      <ng-container *ngIf="showAuthenticationType">
        <div class="title">Send via {{orgModuleNameCore}}</div>

        <div class="authopt">       
        </div>
      </ng-container>
     
      <div class="emailListHolder" *ngIf="selectCoreList.length > 0">
      <ng-container *ngFor="let email of selectCoreList">
        <div class="emailList">

          <div class="left">
            <div class="info first">
              <span> Name</span>
              <p>{{email.name}}</p>
            </div>
  
            <div class="info">
              <span> Email</span>
              <p>{{email.emailid}}</p>
            </div>
          </div>
          
          <div class="right">
            <div class="info assignto">
              <input type="checkbox"  (change)="onNotASignerChange($event, email)" [checked]="email.isNotASigner">
              <span> Assign to someone else</span>
              
            </div>
            
            <div class="act">
              <button color="primary" class="close" mat-icon-button
              (click)="editCore(email)">
              <mat-icon>edit</mat-icon>
            </button>
   
             <button color="primary" class="close" mat-icon-button
               (click)="removeCore(email.emailid)">
               <mat-icon>close</mat-icon>
             </button>
            </div>
           
          </div>


        </div>
        <div class="emailList" [id]="'1_Search' + email.emailid"  *ngIf="email.isNotASigner==true && email.contactAttachWithCores.length==0" >
          <div class="block mt-10 w100" >
            <mat-form-field appearance="outline" class="mt-10 mb-10" style="position: relative;">
              <mat-label>Search {{orgModuleNameContact}}</mat-label>
              <input matInput maxlength="50" placeholder="Type & Select" aria-label="State" [matAutocomplete]="autoContact"
                (input)="searchContacts($event.target.value)" [formControl]="stateCtrl" id="stateCtrlid">
              <mat-autocomplete #autoContact="matAutocomplete">
                <mat-option (click)="contactSelectedNew(contact,email.emailid)"
                  *ngFor="let contact of attachedToContactList" [value]="contact.name">
                  <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
                    <div class="userpic">
                      <img *ngIf="contact.imageUrl!=''" src="{{contact.imageUrl}}" alt="">
                      <span class="username" *ngIf="contact.imageUrl==''" class="username">
                        {{contact.shortName}}
                      </span>
                    </div>
                    <div class="info">
                      <p> {{ contact.name }}</p>
                      <p class="email">{{ contact.email }}</p>
                    </div>
                  </span>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
           
          </div>
        </div>
        <div class="emailList"  [id]="'1_List' + email.emailid" *ngIf="email.isNotASigner==true && email.contactAttachWithCores.length>0" >
        
          <div class="left">
            <div class="info first">
              <span>{{orgModuleNameContact}} Name</span>
              <p>{{email.contactAttachWithCores[0].name}}</p>            
            </div>
                
            <div class="info">
              <span> Email</span>
              <p>{{email.contactAttachWithCores[0].email}}</p>            
            </div>
          </div>
              
         <div class="right"  >
          <div class="info" style="padding-right: 9px;" >
            <mat-select style="width: 150px;" (selectionChange)="OnChnageRelation($event,email)" value="0">
              <mat-option value="0">Select Relation</mat-option>
              <mat-option  *ngFor="let relation of relationList" [value]="relation.relationID">{{relation.relationName}}</mat-option> 
            </mat-select>
          </div>
              <button color="primary" class="close" mat-icon-button
                (click)="removeContactWithCoreCore(email)">
                <mat-icon>close</mat-icon>
              </button>
         </div>
         
        </div>
        
      </ng-container>
      </div>
    
      <div class="sepreator"></div>

      <div class="drive mainLink">
        <ng-container>
          <mat-form-field appearance="fill">
            <input matInput placeholder="Search {{orgModuleNameCore}}" [formControl]="stateCtrl"
              (input)="searchCore($event.target.value)" [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete">
              <mat-option (click)="coreSelected(core)" *ngFor="let core of attachedToCoreList" [value]="core.name">
                <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
                  <div class="userpic">
                    <img *ngIf="core.imageUrl!=''" src="{{core.imageUrl}}" alt="">
                    <span class="username" *ngIf="core.imageUrl==''" class="username">
                      {{core.shortName}}
                    </span>
                  </div>
                  <div class="info">
                    <p> {{ core.name }}</p>
                    <p class="email">{{ core.email }}</p>
                  </div>
                </span>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </ng-container>
      </div>



    </mat-dialog-content>

    <div class="sepreator"></div>

    <mat-checkbox color="primary" [(ngModel)]="AssigneeChecked" (change)="showOptions($event,'Assignee')">Assign the
      same Users as template
    </mat-checkbox>&nbsp;
    
    <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
      <button mat-button color="basic" (click)="closeSendTaskListURL()">Cancel</button>

      <button mat-flat-button style="margin-left: 215px;" class="calltoaction" type="submit" color="primary"
        [disabled]="selectCoreList.length==0"
        (click)="SendEmailForTaskListURL(false)">
        Create & Send
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
          </mat-spinner></mat-icon>
      </button>

      <button mat-flat-button class="calltoaction" type="submit" color="primary"
        [disabled]="selectCoreList.length==0"
        (click)="SendEmailForTaskListURL(true)">
        Create Only
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
          </mat-spinner></mat-icon>
      </button>
    </mat-dialog-actions>

  </ng-template>


   <app-details *ngIf="showDetail"  [ngClass]="{ open: showDetail }" [transactionID]='transactionID'
  [modulenames]='mainModuleNameForDetails' [SendingFor]="sendFrom" [openFor]='openFor'
  (selectedCoreIdForSendTaskListUpdate)=getUpdatedRecord($event) (closeDetail)="getCloseDetails($event)">
  </app-details>

   <app-addnew *ngIf="showAddContact" (closeAdd)="getCloseContacts($event)" [modulename]='Module'
    [ngClass]="{'open': showAddContact}"></app-addnew>

  <app-addnew *ngIf="showAddCore" (closeAdd)="getCloseCore($event)" [name]="searchName" [isShared]="isShare"
    [mainModuleName]='mainModuleName' [modulename]='Module' [SendingFor]="sendFrom" [ngClass]="{'open': showAddCore}"
    (selectedCoreIdForSendTaskList)=getselectedTransactionId($event)>
  </app-addnew>

 <ng-template #selectFavColor>
    <h2 mat-dialog-title>
      <span class="groupIcon"><mat-icon>rocket_launch</mat-icon></span>
      Add Color
      <button mat-icon-button (click)="closeColor()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>
    <mat-dialog-content>


     <div class="color-list">
        <ng-container *ngFor="let col of colors">
          <span
            (click)="selectedColors(col.color)"
            [ngStyle]="{'background-color': col.color}"
            class="color-box">
          </span>
        </ng-container>
      </div>


    </mat-dialog-content>
    <mat-dialog-actions class="mt-10" align="start" fxLayout="row" fxLayoutAlign="space-between center">     
    </mat-dialog-actions>

  </ng-template>

   <ng-template #selectimpFavColor>
    <h2 mat-dialog-title>
      <span class="groupIcon"><mat-icon>rocket_launch</mat-icon></span>
      Add Color
      <button mat-icon-button (click)="closeColor()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>
    <mat-dialog-content>

     <div class="color-list">
        <ng-container *ngFor="let col of colors">
          <span
            (click)="selectedImpColors(col.color)"
            [ngStyle]="{'background-color': col.color}"
            class="color-box">
          </span>
        </ng-container>
      </div>


    </mat-dialog-content>
     <mat-dialog-actions class="mt-10" align="start" fxLayout="row" fxLayoutAlign="space-between center">
    </mat-dialog-actions>

  </ng-template>

<app-loader></app-loader>